/**
 * Item format:
 * {
 *     id(string): the item's id
 *     text(string): text to display for the item
 *     isLeaf(boolean): this item has no child
 *     path(array): array of items [only required in search result]
 *     isPathClickable(boolean): if the path items are clickable or not
 * }
 */

define('commons/flat-tree',['jquery', 'commons/loading-mask', 'commons/search-highlight'], function($, LoadingMask, SearchHighlight) {
    
    var FlatTree = function(containerSelector, options) {
        var self = this;
        
        // Configuration settings
        this.settings = {
            perm: null,
            autoLoad: true,
            nbPanels: 3,
            loadItemUrl: '', // Required
            searchTimeout: 400, // ms
            searchThreshold: 3, // Nb of characters
            data: null, // Additional ajax data
            /**
             * return item node info:
             * {
             *     text(string): display text,
             *     link(boolean): true if it is a link,
             *     attrs(object): node attributes,
             *     events(object): keys -> event names and values -> handler functions,
             *     forceIconMargin(boolean): force the icon margin,
             *     icon(object): {
             *         className(string): icon class name,
             *         attrs(object): node attributes,
             *         events(object): keys -> event names and values -> handler functions    
             *     },
             *     checkbox(object): {
             *         className(string): class name,
             *         type(string): input | span,
             *         attrs(object): node attributes,
             *         events(object): keys -> event names and values -> handler functions
             *     }
             * }
             */
            createItem: function(item) {
                return {
                    text: item.text,
                    link: false,
                    events: null,
                    icon: null,
                    className: '',
                    checkbox: null
                };
            },
            additionalSearchData: function(searchValue, parentId) {},
            resetSearch: function() {}
        };
        $.extend(true, this.settings, options);
        // Check min nb panel;
        this.settings.nbPanels = Math.max(1, this.settings.nbPanels);
        
        this.$container = $(containerSelector).addClass("flat-tree");
        
        // Toolbar
        this.$toolbar = $('<div class="toolbar"></div>').appendTo(this.$container);
        
        var searchButton = $('<button type="button"><span class="fas fa-search"></span></button>').click($.proxy(function() {
        	this._openSearch();
        }, this));
        
        var searchModal = $('<div class="hidden search-modal"></div>');
        var searchExit = $('<button type="button" class="search-exit"><span class="fas fa-times"></span></button>').click($.proxy(this._closeSearch, this)).appendTo(searchModal);
        var search = $('<input type="text" placeholder="Search..." class="search" />').appendTo(searchModal);
        var searchInfo = $('<div class="search-info"></div>').appendTo(searchModal);
        var searchResultsWrapper = $('<div class="search-results-wrapper"></div>').appendTo(searchModal);
        var searchResults = $('<div class="search-results"></div>').appendTo(searchResultsWrapper);
        
	    search.keyup($.proxy(function(e) {
	        window.clearTimeout(this.search.timeout);
	        this.search.timeout = null;
	        var length = search.val().length;
	        
	        if (e.keyCode == 13) {
	        	this._search();
	        } else if (length >= this.settings.searchThreshold) {
	            this.search.timeout = window.setTimeout($.proxy(this._search, this), this.settings.searchTimeout);
	        }
	    }, this));
        
        this.search = {
        	$modal: searchModal,
        	$results: searchResults,
        	$input: search,
        	$info: searchInfo,
        	visible: false,
        	parent: null,
        	timeout: null
        };
        
        $('<div class="search"></div>').appendTo(this.$toolbar).append(searchButton);
        this.$breadcrumb = $('<div class="breadcrumb"></div>').appendTo(this.$toolbar);
        $('<div style="clear: both;"></div>').appendTo(this.$toolbar);
        
        // Panels
        this.$panelContainer = $('<div class="panel-container"></div>');
        this.$container.append(this.$panelContainer, searchModal);
        this.panels = [];

        // Search result
        this.$searchLoadingMask = new LoadingMask(searchResultsWrapper, {});
        
        var button = function(text) {
        	return $('<button type="button" style="font-size: 14px; padding: 5px; margin: 0; border: none; background: none;"></button>').html(text);
        };
        
        var createPanel = function() {
    		var panel = $('<div class="panel"></div>');
    		
        	var wrapper = $('<div class="panel-wrapper"></div>')
	        	//.css('float', 'left')
	        	.css('position', 'relative')
            	.css('width', (100 / self.settings.nbPanels) + '%')
        		.appendTo(self.$panelContainer);
        	
        	var $hidden = $('<span class="hidden"></span>');
        	
        	var $input = $('<input type="text" />')
        		.css('border', '1px solid #c4c4c4')
        		.css('border-radius', '3px')
        		.css('width', '50%')
        		.css('padding', '3px')
        		.css('font-size', '12px');

        	var $next = button('').addClass('fas fa-long-arrow-alt-down');
        	var $prev = button('').addClass('fas fa-long-arrow-alt-up');
        	var $search = button('<span class="fas fa-filter" title="Filter column"></span>').addClass('search hidden');

        	var visible = false;
        	
        	var search = new SearchHighlight({
        		input: $input[0],
        		next: $next[0],
        		prev: $prev[0],
        		scope: panel[0],
        		selector: '.item-value',
        		onMatch: function(item) {
        			var $item = $(item).parents('.item').css('opacity', '1');
        		},
        		onNoMatch: function(item) {
        			$(item).parents('.item').css('opacity', '0.4');
        		},
        		onClear: function(item) {
        			$(item).parents('.item').css('opacity', '1');
        		},
        		onCancel: function() {
        			visible = false;
        			$hidden.fadeOut(100);
        		},
        		select: function(item) {
        			var $item = $(item).parents('.item');
        			var panel = $item.parents('.panel');
        			
        			panel.scrollTop(0);
        			panel.scrollTop($item.position().top - 35);
        		}
        	});
        	
        	var toggleSearch = function() {
    			if (visible) {
    				search.clear();
    				$hidden.fadeOut(100);
    			} else {
    				$hidden.fadeIn(100);
        			$input.focus();
    			}
    			
        		visible = !visible;
        	};
        	
        	$search.click(toggleSearch);
        	
        	$hidden.append($input, $next, $prev);
        	$('<div style="text-align: right; margin-right: 40px; height: 30px"></div>').appendTo(wrapper).append($hidden, $search);
        	
        	return {
        		$panel: panel.data('level', i).appendTo(wrapper),
        		$wrapper: wrapper,
        		$search: search,
        		enable: function() {
        			$search.show();
        		},
        		disable: function() {
        			$search.hide();
        		},
        		reset: function() {
	        		if (visible) {
	        			toggleSearch();
	        		}
        		}
        	};
        };
        
        for(var i = 0; i < this.settings.nbPanels; ++i) {
        	this.panels[i] = createPanel();
        }
        
        $('<div></div>').css('clear', 'left').appendTo(this.$panelContainer);
        this.$loadingMask = new LoadingMask(this.$panelContainer, {});
        
        this._addItemInBreadcrumb(true);
        
        if (this.settings.autoLoad) {
            this.init();
        }
    };
    
    
    FlatTree.prototype.init = function() {
    	var path = null;
    	if (this.settings.data) {
    		if (this.settings.data.path) {
    			path = this.settings.data.path;
    		} else if (this.settings.data.parentId) {
    			path = [this.settings.data.parentId];
    		}
    	}
    	
        this._loadContent(path, 0);
    };
    
    
    FlatTree.prototype._loadContent = function(toLoad, level, parent) {
    	var id = toLoad || '';
    	var path = [];
    	
    	if (Array.isArray(toLoad)) {
    		id = toLoad[0] || '';
    		path = toLoad.slice(1);
    	}
    	
        this.$loadingMask.show();
        if (level === this.panels.length) {
            this._shiftPanelLeft();
            level = this.panels.length - 1;
        }
        
        level = Math.max(0, Math.min(level, this.panels.length - 1));
        for(var i = level; i < this.panels.length; ++i) {
            this.panels[i].$panel.empty();
        }
        
        var self = this;

        $.ajax({
            type: "POST",
            url: this.settings.loadItemUrl,
            data: $.extend({}, this.settings.data, {
                perm: this.settings.perm,
                parentId: id
            }),
            context: this,
            datatype: 'json',
            success: function(items) {
                if (items && items.length > 0) {
                	if (parent) {
	                	for (var i = 0; i < items.length; i++) {
	                		var item = items[i];
	                		if (! item.path) {
	                			item.path = (parent.path||[]).concat([parent]);
	                		}
	                	}
                	}
                	
                    this._addPanelItems(items, this.panels[level]);
                    
                    if (path.length > 0) {
                    	self._loadContent(path, level+1, self._selectItem(path[0], level, true));
                    }
                } else {
                    // No data to display
                }
            },
            complete: function() {
            	if (!path || path.length <= 1) {
            		this.$loadingMask.hide();
            	}
            }
        });
    };
    
    
    FlatTree.prototype.setAdditionalData = function(data) {
        this.settings.data = data;
    };
    
    
    FlatTree.prototype.reset = function(onlyPanel) {
        if (!onlyPanel) {
            this.$breadcrumb.empty();
            this._addItemInBreadcrumb(true);
        }
        for (var i = 0; i < this.panels.length; ++i) {
        	this.panels[i].reset();
        	this.panels[i].disable();
            this.panels[i].$panel.empty();
        }
    };
    
    
    FlatTree.prototype._addPanelItems = function(items, panel) {
    	if (items.length > 0) {
    		panel.reset();
    		panel.enable();
    	}
    	
    	this._addItems(items, panel.$panel, true);
    };

    
    FlatTree.prototype._addItems = function(items, parentNode, isPanel) {
    	for(var i = 0; i < items.length; ++i) {
    		this._addItem($.extend({isPathClickable: true}, items[i]), parentNode, isPanel);
        }
    };
    
    
    FlatTree.prototype._addItem = function(item, parentNode, isPanel) {
        var itemInfo = this.settings.createItem(item);
        var self = this;
        
        if (itemInfo) {
            var node = $('<div></div>').addClass('item').addClass(itemInfo.className).data('item', item).appendTo(parentNode);
            this._attachOverClass(node);
            
            var contentNode = $('<div></div>').addClass('content').appendTo(node);
            
            // Create icon
            if (itemInfo.icon) {
                var iconNode = $('<span></span>').addClass(itemInfo.icon.className).addClass('icon').data('itemInfo', itemInfo).on(itemInfo.icon.events).appendTo(contentNode);
                for (var a in itemInfo.icon.attrs) {
                    iconNode.attr(a, itemInfo.icon.attrs[a]);
                }
            }
            if (itemInfo.icon || itemInfo.forceIconMargin) {
                contentNode.addClass('icon');
            }
            
            // Create item node
            var innerContentNode = $(itemInfo.link ? '<a></a>' : '<span></span>').addClass('ellipsis item-value').text(itemInfo.text).data('itemInfo', itemInfo).on(itemInfo.events).appendTo(contentNode);
            if (itemInfo.link) {
                itemInfo.attrs = $.extend(true, {'href': 'javascript:void(0)'}, itemInfo.attrs);
            }
            for (var a in itemInfo.attrs) {
                innerContentNode.attr(a, itemInfo.attrs[a]);
            }
            
            if (! isPanel) {
            	var inTree = $('<div></div>').css('display', 'none').addClass('additional-icon').appendTo(node).append($('<span></span>').addClass('fas fa-sitemap'));
            	inTree.click(function() {
            		self._goto(item, item.path);
            	});
            	node.mouseenter(function() {
            		inTree.show();
            	});
            	node.mouseleave(function() {
            		inTree.hide();
            	});
                self._attachOverClass(inTree);
            }
        	
            if (!item.isLeaf) {
            	var search = $('<div></div>').css('display', 'none').addClass('additional-icon').appendTo(node).append($('<span></span>').addClass('icon-search'));
            	search.click(function() {
            		self._openSearch(item);
            	});
            	node.mouseenter(function() {
            		search.show();
            	});
            	node.mouseleave(function() {
            		search.hide();
            	});
                self._attachOverClass(search);
            }
            
            // Create checkbox
            if (itemInfo.checkbox) {
            	var checkboxWrapper = $('<div><span></span></div>').addClass('additional-icon').appendTo(node);
            	
                var checkboxNode = $(itemInfo.checkbox.type === 'span' ? '<span></span>' : '<input type="checkbox"/>')
	                .addClass(itemInfo.checkbox.className)
	                .addClass('item-checkbox')
	                .data('itemInfo', itemInfo)
	                .on(itemInfo.checkbox.events)
	                .appendTo(checkboxWrapper.find('span'));
                
                for (var a in itemInfo.checkbox.attrs) {
                    checkboxNode.attr(a, itemInfo.checkbox.attrs[a]);
                }
            }
            
            if (isPanel) {
            	if (!item.isLeaf) {
                    var arrow = $('<div></div>').addClass('arrow').click($.proxy(function($parent, event) {
                        event.stopPropagation();
                        
                        if ($parent.hasClass('selected')) {
                            return;
                        }
                        
                        var t = $(event.currentTarget);
                        t.removeClass('over');
                        t.parent().removeClass('over');
                        
                        var dataItem = $parent.data('item');
                        var dataLevel = $parent.parent().data('level');
                        
                        this._selectItem(dataItem.id, dataLevel);
                        this._loadContent(dataItem.id, dataLevel + 1, dataItem);
                    }, this, node)).appendTo(node).append($('<span></span>').addClass('icon-caret-right'));
                    
                    this._attachOverClass(arrow);
                }
            } else if (item.path) {
                var pathNode = $('<div></div>').addClass('path').data('path', item.path).appendTo(node);
                for (var p = 0; p < item.path.length; ++p) {
                    var pathItem = item.path[p];
                    pathNode.append($(this._createPathItem($.extend({isPathClickable: item.isPathClickable}, pathItem))));
                }
            }
        }
    };
    
    
    FlatTree.prototype._attachOverClass = function(node) {
        node.mouseenter(function() {
            $(this).addClass('over');
        }).mouseleave(function() {
            $(this).removeClass('over');
        });
    };

    
    FlatTree.prototype._selectItem = function(id, level, scrollTo) {
        var panel = this.panels[level].$panel;
        var item;
        panel.children('.item').each(function() {
            var $item = $(this);
            
            if ($item.data('item').id === id) {
            	item = $item.data('item');
                $item.addClass('selected');
                if (scrollTo) {
                	$(panel).scrollTop(0);
                	$(panel).scrollTop($item.position().top - 35);
                }
            } else {
                $item.removeClass('selected');
            }
        });
        
        return item;
    };
    
    
    FlatTree.prototype._findSelectItem = function(level) {
        var panel = this.panels[level].$panel;
        var children = panel.children();
        for(var i = 0; i < children.length; ++i) {
            var $item = $(children[i]);
            if($item.hasClass('selected')) {
                return $item;
            }
        }
        return null;
    };
    
    
    FlatTree.prototype._addItemInBreadcrumb = function(home, itemData) {
        var node;
        if (home) {
            node = $('<span class="icon-home home"></span>');
        } else {
            $('<span class="icon-angle-right separator"></span>').appendTo(this.$breadcrumb);
            var selectedItem = itemData || this._findSelectItem(0).data('item');
            node = $('<span class="item">' + selectedItem.text + '</span>').data('item', selectedItem);
        }
        
        node.click($.proxy(function(event) {
            var item = $(event.currentTarget).data('item');
            var children = this.$breadcrumb.children();
            if (!item && home) {
                children.slice(1).remove();
            } else {
                var index = null;
                for (var i = 0; i < children.length; ++i) {
                    var $child = $(children[i]);
                    var data = $child.data('item');
                    if (data && data.id == item.id) {
                        index = i;
                        break;
                    }
                }
                children.slice(index + 1).remove();
            }
            this.reset(true);
            this._loadContent(item ? item.id : this.settings.data != null ? this.settings.data.parentId : null, 0, item ? item : undefined);
        }, this)).appendTo(this.$breadcrumb);
        
        this._attachOverClass(node);
    };
    
    
    FlatTree.prototype._shiftPanelLeft = function() {
        this._addItemInBreadcrumb();
        for(var i = 0; i < this.panels.length; ++i) {
            this.panels[i].reset();
            
            if (i === 0) {
                this.panels[i].$panel.empty();
                continue;
            }
            var previousPanel = this.panels[i - 1].$panel;
            var currentPanel = this.panels[i].$panel;
            var top = currentPanel.scrollTop();
            currentPanel.children().appendTo(previousPanel);
            previousPanel.scrollTop(top);
            currentPanel.empty();
        }
    };
    
    
    FlatTree.prototype._openSearch = function(parent) {
    	var self = this;
    	
    	if (! this.search.visible || parent) {
    		this.search.$info.empty();
    		this.search.parent = null;
	    	this.search.$results.empty();
	    	this.search.$input.val('');
	    	this.settings.resetSearch();
	    	
	    	this.search.visible = true;
    	}

    	if (parent) {
    		this.search.parent = parent;
    		
    		var parentBlob = $('<span><strong>parent</strong>: ' + parent.text + '</span>').appendTo(this.search.$info);
    		var closeParent = $('<button type="button" class="close-parent fas fa-times"></button>').appendTo(parentBlob);
    		closeParent.click(function() {
    			self.search.$info.empty();
    			self.search.parent = null;
    			self._search();
    		});
    	} else {
    		this.search.$info.empty();
    	}
    	
    	this.search.$modal.fadeIn(200);
    	this.search.$input.focus();

    	self._search();
    };

    FlatTree.prototype._closeSearch = function() {
    	this.search.visible = false;
    	this.search.$modal.fadeOut(200);
    };
    
    FlatTree.prototype._search = function() {
    	this.search.$results.empty();
        this.$searchLoadingMask.show();
        
        $.ajax({
            type: "GET",
            url: this.settings.loadItemUrl,
            data: this._generateSearchData(this.search.$input.val(), this.search.parent ? this.search.parent.id : null),
            context: this,
            datatype: 'json',
            success: function(items) {
                if(items && items.length > 0) {
                    this._addItems(items, this.search.$results, false);
                } else {
                	this.search.$results.html('<div class="empty-result">No results</div>');
                }
            },
            complete: function() {
                this.$searchLoadingMask.hide();
            }
        });
    };
    
    
    FlatTree.prototype._generateSearchData = function(searchValue, parentId) {
    	return $.extend({}, this.settings.data, this.settings.additionalSearchData(searchValue, parentId), {
            search: searchValue,
            parentId: parentId,
            perm: this.settings.perm
        });
    };
    
    
    FlatTree.prototype._goto = function(item, path) {
    	var parentSearch = this.search.parent;
    	
    	this._closeSearch();
        this.reset(false);
        
        var actualPath = [];
        if (parentSearch) {
        	if (parentSearch.path) {
        		actualPath = actualPath.concat(parentSearch.path);
        	}
        	actualPath.push(parentSearch);
        }
        if (path) {
        	actualPath = actualPath.concat(path);
        }
        
        var parent;
        for(var i = 0; i < actualPath.length; ++i) {
            var it = actualPath[i];
            if(it.id === item.id) {
                break;
            }
            this._addItemInBreadcrumb(false, it);
            parent = it;
        }
        
        if (parent) {
        	this._loadContent([parent.id, item.id], 0, parent);
        } else {
        	this._loadContent([null, item.id], 0);
        }
    };
    
    
    FlatTree.prototype._createPathItem = function(item) {
        var pathItem = $('<span class="path-item"></span>');
        pathItem.append($('<span class="icon-angle-right separator"></span>'));

        var itemInfo = this.settings.createItem(item);
        var content;
        if (itemInfo && itemInfo.link && itemInfo.attrs && itemInfo.attrs.href) {
            content = $('<a class="path-content" href="' + itemInfo.attrs.href + '">' + item.text + '</a>');
        } else {
            content = $('<span class="path-content">' + item.text + '</span>');
        }
        
        if (item.isPathClickable) {
            content.click($.proxy(function(event) {
            	event.preventDefault();
            	
            	this._goto(item, $(event.currentTarget).parent().parent().data('path'));
            }, this));
            this._attachOverClass(content);
        } else {
            content.addClass("no-over");
        }
        pathItem.append(content);
        return pathItem;
    };
    
    
    return FlatTree;
});
